import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
} from "@mui/material";

import ViewMap from '../../../contents/view_map'
import PlayerAndContentsList from '../../../contents/player_and_contents_list'
import BottomNavi from '../../../items/bottom_navigation'
import Proggress from '../../../items/progress'
import FailedToLoad from '../../failed_to_load'

import { MobileDispFlex, PcDispFlex, MainWrapper } from '../../../const/style'
import { GetContentByUUID, LoadMutate } from '../../../functions/get_data_swr';


function ReadOnlyMovieMap(props) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const [value, setValue] = useState(1);

  const handleClick = () => {
    return
  }

  // 指定URLのコンテンツ情報を取得
  const selectUUID = searchParams.get("contents_uuid")
  const url = `content_by_uuid/?contents_uuid=${selectUUID}`
  const { content, isContentsLoading, isContentsError } = GetContentByUUID(url);

  if (isContentsError) return <FailedToLoad />
  if (isContentsLoading) return <Proggress />

  return (
    <>
      {/* PC画面用 */}
      <PcDispFlex>
        <Grid container>
          <Grid item md={6}>
            <PlayerAndContentsList
              contents={content}
              selectContent={content[0]}
              handleClick={handleClick}
              contentsCount={1}
              searchConditions={''}
              selectTag={null}
            />
          </Grid>
          <Grid item md={6}>
            <ViewMap
              fullscreen={true}
              contents={content}
              selectContent={content[0]}
              handleClick={handleClick}
              mapHeight='100%'
            />
          </Grid>
        </Grid>
      </PcDispFlex>
      {/* スマホ・タブレット画面用 */}
      <MobileDispFlex>
        {value === 1 &&
          <Grid container>
            <Grid item xs={12} >
              <PlayerAndContentsList
              contents={content}
              selectContent={content[0]}
              handleClick={handleClick}
              contentsCount={1}
              searchConditions={''}
              selectTag={null}
              />
            </Grid>
          </Grid>
        }
        {value === 2 &&
          <MainWrapper>
            <ViewMap
              fullscreen={true}
              contents={content}
              selectContent={content[0]}
              handleClick={handleClick}
              mapHeight='calc(100vh - 89px)'
            />
          </MainWrapper>
        }
        <BottomNavi
          value={value}
          setValue={setValue}
          navigate={navigate}
        />
      </MobileDispFlex>
    </>
  )
}

export default ReadOnlyMovieMap;
